<div class="background-color-white full-width shadow-large"
     fxLayoutAlign="start stretch"
     *ngIf="goodToKnow">
    <div class="padding-1" ngClass.gt-sm="padding-5" fxLayout="column">
        <h3 fxHide fxShow.gt-sm>Good to know</h3>

        <div class="margin-top-3">
            <app-markdown-renderer [text]="goodToKnow"></app-markdown-renderer>
        </div>
    </div>
</div>
